<template>
  <div v-loading="loading" element-loading-spinner="el-icon-loading">
    <div class="d-flex align-items-center justify-content-between mb-2">
      <div class="d-flex align-items-center">
        <h6 class="m-0">{{ $l('form_header_contacts') || '客户联系人' }}</h6>
        <el-divider direction="vertical" v-if="!disabled" />
        <b-button
          v-if="!disabled"
          size="sm"
          variant="outline-success"
          @click="addContacts"
          :disabled="enableEdit"
        >
          {{ $l('btn_addContacts') || '新增联系人' }}
        </b-button>
      </div>
      <div>
        <vxe-button
          size="mini"
          circle
          @click="getData()"
          :disabled="enableEdit"
        >
          <i class="vxe-button--icon vxe-icon--refresh" />
        </vxe-button>
      </div>
    </div>

    <div class="cust-contacts-list">
      <el-form
        v-for="(form, index) in listContacts"
        :key="index"
        ref="form"
        :model="form"
        :rules="rules"
        size="mini"
        label-position="top"
        :disabled="!form.enableEdit"
      >
        <div class="d-flex">
          <div class="d-flex flex-column">
            <div class="flex-grow-1">
              <div @click="uploadAvatar(form)">
                <el-avatar
                  shape="square"
                  :src="form.contactAvatarUrl || defaultAvatar"
                />
              </div>
              <div
                v-if="!enableEdit && !form.enableEdit && !disabled"
                class="text-center mt-2"
              >
                <el-tooltip
                  effect="dark"
                  :content="$l('INDEX.btn_tips_del') || '删除'"
                  placement="bottom"
                >
                  <i
                    class="el-icon-delete text-danger tool-btn"
                    @click="deleteContacts(form)"
                  />
                </el-tooltip>
                <el-tooltip
                  effect="dark"
                  :content="$l('INDEX.btn_tips_edit') || '编辑'"
                  placement="bottom"
                >
                  <i
                    class="el-icon-edit tool-btn"
                    @click="editContacts(form)"
                  />
                </el-tooltip>
              </div>
            </div>
          </div>
          <div style="flex: 1; padding-left: 16px">
            <el-row :gutter="10">
              <el-col :span="8">
                <el-form-item
                  :label="$l('form_label_contactName') || '姓名'"
                  prop="contactName"
                >
                  <el-input
                    v-model="form.contactName"
                    :placeholder="
                      $l('form_placeholder_contactName') || '请输入姓名'
                    "
                    maxlength="50"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$l('form_label_contactJob') || '职务'"
                  prop="contactJob"
                >
                  <el-input
                    v-model="form.contactJob"
                    :placeholder="
                      $l('form_placeholder_contactJob') || '请输入职务'
                    "
                    maxlength="50"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$l('form_label_contactMobile') || '联系电话'"
                  prop="contactMobile"
                >
                  <el-input
                    v-model="form.contactMobile"
                    :placeholder="
                      $l('form_placeholder_contactMobile') || '请输入联系电话'
                    "
                    maxlength="50"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item
                  :label="$l('form_label_contactEmail') || '邮件地址'"
                  prop="contactEmail"
                >
                  <el-input
                    v-model="form.contactEmail"
                    :placeholder="
                      $l('form_placeholder_contactEmail') || '请输入邮件地址'
                    "
                    maxlength="50"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$l('form_label_contactPhone') || '固定电话'"
                >
                  <el-input
                    v-model="form.contactPhone"
                    :placeholder="
                      $l('form_placeholder_contactPhone') || '请输入固定电话'
                    "
                    maxlength="50"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  :label="$l('form_label_contactAddress') || '通讯地址'"
                  prop="contactAddress"
                >
                  <el-input
                    v-model="form.contactAddress"
                    :placeholder="
                      $l('form_placeholder_contactAddress') || '请输入通讯地址'
                    "
                    maxlength="500"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  :label="$l('form_label_contactMemo') || '业务职责说明'"
                >
                  <el-input
                    v-model="form.contactMemo"
                    :placeholder="
                      $l('form_placeholder_contactMemo') || '请输入业务职责说明'
                    "
                    maxlength="200"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div
          v-if="form.enableEdit && !disabled"
          class="my-2 d-flex justify-content-end"
        >
          <el-button size="small" @click="cancelEdit(index)">
            {{ $l('INDEX.btn_cancel') || '取消' }}
          </el-button>
          <el-button
            type="primary"
            size="small"
            @click="saveContacts(form, index)"
          >
            {{ $l('INDEX.btn_save') || '保存' }}
          </el-button>
        </div>
      </el-form>

      <EmptyContent v-if="!listContacts || !listContacts.length" />
    </div>
  </div>
</template>

<script>
import { VXETable } from 'vxe-table'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import EmptyContent from '../empty-content'
const initContacts = {
  contactAvatarCode: '',
  contactAvatarUrl: '',
  enableEdit: true,
}
export default {
  components: { EmptyContent },
  mixins: [EditLoading],
  props: {
    custCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      defaultAvatar: `${this.$baseUrl}image/theme/default/avatar.png`,
      loading: false,
      listContacts: [],
      currContacts: {},
      rules: {
        contactName: [
          {
            required: true,
            message: this.$l('form_placeholder_contactName') || '请输入姓名',
            trigger: 'change',
          },
        ],
        contactJob: [
          {
            required: true,
            message: this.$l('form_placeholder_contactJob') || '请输入职务',
            trigger: 'change',
          },
        ],
        contactMobile: [
          {
            required: true,
            message:
              this.$l('form_placeholder_contactMobile') || '请输入联系电话',
            trigger: 'change',
          },
        ],
        contactEmail: [
          {
            required: true,
            message:
              this.$l('form_placeholder_contactEmail') || '请输入邮件地址',
            trigger: 'change',
          },
        ],
        contactAddress: [
          {
            required: true,
            message:
              this.$l('form_placeholder_contactAddress') || '请输入通讯地址',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    enableEdit() {
      return this.listContacts.some((contacts) => !!contacts.enableEdit)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.custCode) return
      this.loading = true
      const res = await this.$api
        .masterCustomerContactsListApi({ custCode: this.custCode })
        .catch(() => null)
      this.loading = false
      if (!res) return
      const data = res.body?.data || []
      this.listContacts = data.map((item) => ({ ...item, enableEdit: false }))
    },
    addContacts() {
      this.listContacts.push({ ...initContacts })
      this.currContacts = null
    },
    async deleteContacts({ custContactCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .masterCustomerContactsDelApi({ custContactCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.getData()
    },
    async uploadAvatar(contacts) {
      if (this.disabled) return
      if (!contacts.enableEdit) return

      const { file } = await VXETable.readFile({
        types: ['jpeg', 'JPEG', 'jpg', 'JPG', 'png', 'PNG', 'gif', 'GIF'],
      }).catch(() => ({}))
      if (!file) return

      if (this.loadingOpen()) return
      const avatar = await this.$api
        .SYS_UPLOAD(file)
        .then((res) => ({
          fileCode: res.body.fileId,
          fileUrl: res.body.url,
        }))
        .catch(() => null)
      this.loadingClose()
      if (!avatar) return

      contacts.contactAvatarCode = avatar.fileCode
      contacts.contactAvatarUrl = avatar.fileUrl
    },
    editContacts(contacts) {
      if (this.enableEdit) return
      this.currContacts = JSON.parse(JSON.stringify(contacts))
      contacts.enableEdit = true
    },
    async saveContacts(contacts, index) {
      if (!(await validate.formValidate([this.$refs.form[index]]))) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .masterCustomerContactsSaveApi({ ...contacts, custCode: this.custCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.getData()
    },
    cancelEdit(index) {
      if (!this.currContacts) {
        this.listContacts.splice(index, 1)
      } else {
        this.$set(this.listContacts, index, { ...this.currContacts })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-avatar {
    width: 80px;
    height: 80px;
    cursor: pointer;
  }

  .cust-contacts-list {
    .tool-btn {
      font-size: 20px;
    }
    .el-form {
      background-color: #f4f6f9;
      padding: 16px;
      padding-bottom: 6px;
      border-radius: 5px;
      margin-bottom: 16px;
    }
    .el-form:last-child {
      margin-bottom: 0;
    }
    .no-data {
      color: #606266;
      font-size: 13px;
    }
  }
}
</style>
